import React from 'react'
import { ButtonGroup, DialogWrapper } from '@reapitform/common-ui'
import { Button } from '@reapit/elements/core/button'

interface ConfirmCopyDialogProps {
  isOpen: boolean
  title: string
  message: string
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/**
 * A confirm-before-copy modal used when duplicating a form version from the forms grid. The confirm button
 * is non-destructive (this is a safe, additive action); the caller performs the copy and surfaces any error.
 */
export const ConfirmCopyDialog: React.FC<ConfirmCopyDialogProps> = ({
  isOpen,
  title,
  message,
  busy,
  onConfirm,
  onCancel,
}) => {
  const footer = (
    <ButtonGroup alignment="right">
      <Button size="medium" variant="secondary" disabled={busy} onClick={onCancel} type="button">
        Cancel
      </Button>
      <Button size="medium" variant="primary" isBusy={busy} disabled={busy} onClick={onConfirm} type="button">
        Copy
      </Button>
    </ButtonGroup>
  )

  return (
    <DialogWrapper isModalOpen={isOpen} handlerModalClose={onCancel} hasCloseButton title={title} footer={footer}>
      {message}
    </DialogWrapper>
  )
}
